import { useMemo, useState } from 'react';

export function sgAnalyticsDateInput(daysAgo = 0) {
    const d = new Date(Date.now() - daysAgo * 24 * 60 * 60 * 1000);
    return d.toLocaleDateString('en-CA', { timeZone: 'Asia/Singapore' });
}

/** Force category dates so Recharts does not keep a wider time domain after From/To change. */
export const ANALYTICS_DATE_XAXIS_PROPS = {
    dataKey: 'date',
    type: 'category',
    interval: 'preserveStartEnd',
    tick: { fontSize: 11 },
    minTickGap: 16,
};

/** Keep only rows whose `date` (YYYY-MM-DD) is inside From/To. */
export function clipAnalyticsChartData(data, from, to) {
    if (!Array.isArray(data)) return [];
    if (!from || !to) return data;
    const lo = from <= to ? from : to;
    const hi = from <= to ? to : from;
    return data.filter((row) => {
        const d = String(row?.date || '');
        return d >= lo && d <= hi;
    });
}

/**
 * Default chart range: last 30 calendar days through today (Singapore).
 * Example: 22 Sep 2026 → From 23 Aug 2026, To 22 Sep 2026.
 */
export function useAnalyticsChartRange() {
    const today = useMemo(() => sgAnalyticsDateInput(0), []);
    const fromDefault = useMemo(() => sgAnalyticsDateInput(30), []);
    const [chartFrom, setChartFrom] = useState(fromDefault);
    const [chartTo, setChartTo] = useState(today);

    return {
        chartFrom,
        setChartFrom,
        chartTo,
        setChartTo,
        rangeReady: Boolean(chartFrom) && Boolean(chartTo),
    };
}
